/* ============================================
   DOSE VERDE — Product Page tabs
   Converte os blocos collapsible_tab do Dawn em
   abas horizontais (uma aberta por vez) com ARIA.
   Com MutationObserver para sobreviver a trocas
   de variante do product-info.
   ============================================ */
(function () {
  'use strict';

  function initTabs(container) {
    var info = container.querySelector('.product__info-container');
    if (!info) return;

    // A transformação move o conteúdo original; nunca a execute duas vezes.
    if (info.querySelector('.dv-tabs[data-initialized="true"]')) return;

    var accordions = Array.prototype.slice.call(
      info.querySelectorAll('.product__accordion')
    );
    if (accordions.length < 2) return;

    var prefix = 'dv-tab-' + sectionId(container) + '-';
    var tablist = document.createElement('div');
    tablist.className = 'dv-tabs__list';
    tablist.setAttribute('role', 'tablist');

    var tabs = [];
    var panels = [];

    accordions.forEach(function (acc) {
      var details = acc.querySelector('details');
      if (!details) return;
      var summary = details.querySelector('summary');
      var content = details.querySelector('.accordion__content');
      if (!summary || !content) return;

      var index = tabs.length;
      var tabId = prefix + index;
      var panelId = 'Panel-' + prefix + index;

      // Botão da aba
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'dv-tab';
      tab.id = tabId;
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panelId);
      tab.textContent = summary.textContent.replace(/[\s]+/g, ' ').trim();
      tablist.appendChild(tab);
      tabs.push(tab);

      // Painel
      var panel = document.createElement('div');
      panel.className = 'dv-tabpanel';
      panel.setAttribute('role', 'tabpanel');
      panel.id = panelId;
      panel.setAttribute('aria-labelledby', tabId);
      panel.setAttribute('tabindex', '0');
      panel.appendChild(content);
      details.parentNode.replaceChild(panel, details);
      panels.push(panel);

      tab.addEventListener('click', function () {
        select(index);
      });
      tab.addEventListener('keydown', function (e) {
        onKey(e, index);
      });
    });

    if (tabs.length < 2) return;

    // .dv-tabs wrapper
    var wrapper = document.createElement('div');
    wrapper.className = 'dv-tabs';
    wrapper.setAttribute('data-initialized', 'true');
    info.insertBefore(wrapper, accordions[0]);
    wrapper.appendChild(tablist);
    panels.forEach(function (panel) {
      wrapper.appendChild(panel);
    });

    // Move tabela de info para o primeiro tabpanel
    var infoTable = info.querySelector('.dv-info-table');
    if (infoTable && panels[0]) {
      var tabContent = document.createElement('div');
      tabContent.className = 'dv-tabpanel__content';
      var descContent = panels[0].querySelector('.accordion__content');
      if (descContent) {
        tabContent.appendChild(descContent);
      }
      panels[0].appendChild(tabContent);
      panels[0].appendChild(infoTable);
    }

    function select(index) {
      tabs.forEach(function (tab, j) {
        var open = j === index;
        panels[j].hidden = !open;
        tab.setAttribute('aria-selected', open ? 'true' : 'false');
        tab.setAttribute('tabindex', open ? '0' : '-1');
      });
    }

    function onKey(e, index) {
      var next = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        next = (index + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        next = (index - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        next = 0;
      } else if (e.key === 'End') {
        next = tabs.length - 1;
      }
      if (next !== null) {
        e.preventDefault();
        select(next);
        tabs[next].focus();
      }
    }

    select(0);
  }

  function sectionId(container) {
    var m = (container.getAttribute('data-section') || '').match(/[\w-]+/);
    return m ? m[0] : 'x';
  }

  function boot() {
    document.querySelectorAll('product-info').forEach(function (el) {
      initTabs(el);
      if (!el.hasAttribute('data-dv-tabs-watching')) {
        var info = el.querySelector('.product__info-container');
        if (!info) return;
        el.setAttribute('data-dv-tabs-watching', '1');
        new MutationObserver(function () {
          if (!info.querySelector('.dv-tabs') && info.querySelectorAll('.product__accordion details').length >= 2) {
            initTabs(el);
          }
        }).observe(info, { childList: true, subtree: true });
      }
    });
  }

  /* ============================================
     Wishlist — persistência em localStorage
     ============================================ */
  var WISHLIST_KEY = 'dv-wishlist';

  function readWishlist() {
    try {
      return JSON.parse(window.localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (e) {
      /* localStorage indisponível (modo privado/quota) — ignora */
    }
  }

  function toggleWishlist(el) {
    var id = el.getAttribute('data-product-id');
    if (!id) return;
    var ids = readWishlist();
    var index = ids.indexOf(id);
    var active;
    if (index === -1) {
      ids.push(id);
      active = true;
    } else {
      ids.splice(index, 1);
      active = false;
    }
    writeWishlist(ids);
    setWishlistState(el, active);
  }

  function setWishlistState(el, active) {
    el.classList.toggle('is-active', active);
    el.setAttribute('aria-pressed', active ? 'true' : 'false');
    el.setAttribute('aria-label', active ? el.dataset.removeLabel : el.dataset.addLabel);
  }

  function initWishlist() {
    var ids = readWishlist();
    document.querySelectorAll('[data-dv-wishlist]').forEach(function (el) {
      if (el.hasAttribute('data-dv-wishlist-bound')) return;
      el.setAttribute('data-dv-wishlist-bound', '1');

      setWishlistState(el, ids.indexOf(el.getAttribute('data-product-id')) !== -1);

      el.addEventListener('click', function () {
        toggleWishlist(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('DOMContentLoaded', initWishlist);
  } else {
    boot();
    initWishlist();
  }
})();
